import { regexes } from '../utils/regexes.const';

/**
 * @function validateDate
 * @desc returns true if the dateString conforms to InsureNet date format: dd.MM.yyyy
 * @param {string} dateString a string representation of a date, hopefully in an InsureNet compatible format
 * @returns {boolean} true if the string represents a date in format dd.MM.yyyy, otherwise false
 */
export function validateDate(dateString: string): boolean {
    return regexes.insureNetDateFormat.test(dateString);
}

export function isValidIMEI(imei: string): boolean {
    if (!/^[0-9]{15}$/gm.test(imei)) {
        return false;
    }

    const sum = imei
        .split('')
        .flatMap((x, i) => (i % 2 === 0 ? x : (2 * Number(x)).toString().split('')))
        .reduce((total, x) => total + Number(x), 0);

    if (sum % 10 !== 0) {
        return false;
    }

    return true;
}
